import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./styles/index.scss";
import { registerSW } from "virtual:pwa-register";

// Register service worker for PWA functionality
registerSW({
  onNeedRefresh() {
    console.log("New content available, please refresh.");
    // You could show a toast notification here
  },
  onOfflineReady() {
    console.log("App ready to work offline");
  },
  onRegisteredSW(swUrl, _registration) {
    console.log("SW Registered: " + swUrl);
  },
  onRegisterError(error) {
    console.log("SW registration error", error);
  },
});

// PWA Install Detection - Global state for React components to use
// The actual install prompt UI is now handled by:
// 1. Onboarding flow (for first-time users)
// 2. Settings screen (for returning users)
// 3. InstallPromptModal component (can be triggered programmatically)

interface BeforeInstallPromptEvent extends Event {
  prompt(): Promise<void>;
  userChoice: Promise<{ outcome: "accepted" | "dismissed" }>;
}

declare global {
  interface WindowEventMap {
    beforeinstallprompt: BeforeInstallPromptEvent;
  }
  interface Window {
    deferredInstallPrompt: BeforeInstallPromptEvent | null;
  }
}

// Store the deferred prompt globally so React components can access it
window.deferredInstallPrompt = null;

// Listen for install prompt and store it
window.addEventListener("beforeinstallprompt", (e) => {
  e.preventDefault();
  window.deferredInstallPrompt = e;
  console.log("PWA install prompt captured and deferred");
});

// Listen for successful install
window.addEventListener("appinstalled", () => {
  console.log("PWA was installed");
  window.deferredInstallPrompt = null;
});

// Render React app
ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
